{
  "columns": [],
  "buttons": [],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "invoiceAuthAdjustmentBatchResultList",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
